export enum WorkspaceAccessOperation {
    createUser = "ef4cb7da-b7b8-4159-b0b1-fdac893fb8ae",
    readUser = "2245ca58-c3eb-479e-9af9-3f89dad0b804",
    updateUser = "8cbb7848-a583-4d69-8f12-64c41269d1ca",
    deleteUser = "0455d428-8443-4cd9-bd72-3066617cd43e",
    createUserTemplate = "d818a831-6e3d-40e8-83e5-593c3232a600",
    readUserTemplate = "962f5293-5d18-4f24-bbfe-347d76524d7d",
    updateUserTemplate = "04190637-ee0a-4db9-b86f-b6f566f39be4",
    deleteUserTemplate = "ef94b582-0a1d-48db-bf86-2272c22ef4cd",
    createPrivateInvite = "7c054e50-cc68-47d2-a17a-65d08c75043e",
    readPrivateInvite = "72dbe875-8197-416a-900a-bab3d6f3d3d2",
    updatePrivateInvite = "4642631d-07ce-4316-a39c-2cf5c01f990c",
    deletePrivateInvite = "84eb1a35-0faf-457c-b56e-4bc7e18d21fd",
    createUserDefinedObject = "9d4f8092-2478-4219-9e42-fa557d316160",
    readUserDefinedObject = "fde68c5d-9a03-45cf-b895-6385cf4aac80",
    updateUserDefinedObject = "0231dd5f-3c32-4816-9010-dc294fddff5d",
    deleteUserDefinedObject = "832254aa-9f11-4f52-a607-c9a77498b0c4",
    updateMetadata = "5d31d6d9-94ca-4c02-9a6c-fe2c167f3609",
    createTicket = "050e5c1d-d882-462b-b255-c33a54860674",
    readTicket = "77567dea-6f12-4845-8fea-753a3922c4e7",
    updateTicket = "14ce8b55-27c6-475c-9b3d-d89333e81335",
    deleteTicket = "071bedfd-186b-444c-8ffe-8a5c05668cad",
}
